// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: cerbos/effect/v1/effect.proto

/* eslint-disable */

export const protobufPackage = "cerbos.effect.v1";

export enum Effect {
  EFFECT_UNSPECIFIED = 0,
  EFFECT_ALLOW = 1,
  EFFECT_DENY = 2,
  EFFECT_NO_MATCH = 3,
}
